import React from "react";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import TestimonialsSection from "./TestimonialsSection";
import Footer from "./Footer";
import Navbar from "./Navbar";
import ComingSoonNavbar from "./ComingSoonNavbar";
import Subscribe from "./Subscribe";
import CookieBanner from "./CookieBanner";
import AppDownloadSection from "./AppDownloadSection";
import FooterLinks from "./FooterLinks";
import CombinedSection from "./CombinedSection";

const Homepage = () => {
  return (
    <>
      <Navbar />
      <ComingSoonNavbar/>
      <Subscribe/>
      <HeroSection />
      <FeaturesSection />
      {/* <TestimonialsSection />*/}

        
      <CookieBanner />
      <CombinedSection />
      <Footer />
       
    </>
  );
};

export default Homepage;
